import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Configs } from "../../common/config";
import { useForm } from "react-hook-form";

//--- Material Control
import {
  Button,
  TextField,
  IconButton,
  Tooltip,
  Popover,
  MenuItem,
  Fab,
} from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Select from 'react-select';

//--- Styles
import "./classified.scss";

//--- Material Icon
import DeleteCircle from "@material-ui/icons/DeleteForever";
import AddCircle from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
//import FilterListIcon from '@material-ui/icons/FilterList';
import SearchIcon from "@material-ui/icons/Search";
import ClearAllIcon from "@material-ui/icons/ClearAll";
import RefreshIcon from "@material-ui/icons/Refresh";

//--- Component
import ListClassified from "./list-classified/list-classified.view";
import DeleteDialog from "../../components/dialog-delete/dialog-delete.view";
import ConfirmDialog from "../../components/confirm-modal/confirm-modal";
import AddClassified from "./add-classified/add-classified.view";
import EditClassified from "./edit-classified/edit-classified.view";
import * as MasterActions from "../../redux/store/master-data/master-data.store";
import * as provinceAction from '../../redux/store/province-management/province.store';

//--- Notifications
import ShowNotification from "../../components/react-notifications/react-notifications";
import { NotificationMessageType } from "../../utils/configuration";
import * as viVN from "../../language/vi-VN.json";

//--- Redux store
import * as faqActions from "../../redux/store/faq/faq.store";
import * as classifiedActions from "../../redux/store/classified/classified.store";
import * as securityMatrixAction from "../../redux/store/security-matrix/security-matrix.store";
import { makeStyles } from "@material-ui/core/styles";
import { useHistory } from "react-router-dom";
import { UrlCollection } from "./../../common/url-collection";
import * as appActions from "../../core/app.store";
import { set } from "immutable";
// const useStyles = makeStyles((theme) => ({
//   formControl: {
//     margin: theme.spacing(1),
//     minWidth: 120,
//   },
//   selectEmpty: {
//     marginTop: theme.spacing(2),
//   },
// }));

const listStatus = [
  {
    value: 0,
    label: 'Không kích hoạt'
  },
  {
    value: 1,
    label: 'Kích hoạt'
  }
];

const areaList = [
  { from: null, to: null, value: 0, label: 'Tất cả diện tích' },
  { from: 0, to: 100, value: 1, label: 'Dưới 100 m2' },
  { from: 100, to: 200, value: 2, label: 'Từ 100 đến 200 m2' },
  { from: 200, to: 300, value: 3, label: 'Từ 200 đến 300 m2' },
  { from: 300, to: 400, value: 4, label: 'Từ 300 đến 400 m2' },
  { from: 400, to: 500, value: 5, label: 'Từ 400 đến 500 m2' },
  { from: 500, to: 1000, value: 6, label: 'Từ 500 đến 1000 m2' },
  { from: 1000, to: 'max', value: 7, label: 'Trên 1000 m2' }
];

const landPriceList = [
  { from: null, to: null, value: 0, label: 'Tất cả giá' },
  { from: 0, to: 500000000, value: 1, label: 'Dưới 500 triệu' },
  { from: 500000000, to: 1000000000, value: 2, label: '500 đến đến 1 tỷ' },
  { from: 1000000000, to: 2000000000, value: 3, label: 'Từ 1 đến 2 tỷ' },
  { from: 2000000000, to: 3000000000, value: 4, label: 'Từ 2 đến 3 tỷ' },
  { from: 3000000000, to: 5000000000, value: 5, label: 'Từ 3 đến 5 tỷ' },
  { from: 5000000000, to: 7000000000, value: 6, label: 'Từ 5 đến 7 tỷ' },
  { from: 7000000000, to: 10000000000, value: 7, label: 'Từ 7 đến 10 tỷ' },
  { from: 10000000000, to: 20000000000, value: 8, label: 'Từ 10 đến 20 tỷ' },
  { from: 20000000000, to: 30000000000, value: 9, label: 'Từ 20 đến 30 tỷ' },
  { from: 30000000000, to: 'max', value: 10, label: 'Trên 30 tỷ' }
];

export default function Faq(props) {
  //  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [newsModels, setNewsModels] = useState();
  const { pathname } = props.location;
  const { langId } = useSelector((state) => state.language);
  const [totalItemCount, setTotalItemCount] = useState();
  const [searchData, setSearchData] = useState({
    //  categoryId: 1,
    keyword: "",
    user: "",
    // description: '',
    status: 2,
  });
  const [classId, setClassId] = useState();
  const [newsxmin, setNewsxmin] = useState();
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("createdDate");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(Configs.DefaultPageSize);

  const [isDelete, setIsDelete] = useState(false);
  const [isShowTrash, setIsShowTrash] = useState(false);

  const { register, handleSubmit } = useForm({
    mode: "all",
    reValidateMode: "onBlur",
  });

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    let _langId = langId;
    let _page = page;
    let _rowsPerPage = rowsPerPage;
    let _order = order;
    let _orderBy = orderBy;
    let _isDelete = isDelete;
    let _keyword = undefined;
    let _user = undefined;
    let _isActive = undefined;
    let _provinceId = undefined;
    let _directionIds = undefined;
    let _statusId = undefined;
    let _realEstateTypeId = undefined;

    if (queryParams.get("langId")) {
      _langId = queryParams.get("langId");
    }
    if (queryParams.get("pageIndex")) {
      _page = queryParams.get("pageIndex");
      setPage(Number(_page));
    }
    if (queryParams.get("pageSize")) {
      _rowsPerPage = queryParams.get("pageSize");
      setRowsPerPage(Number(_rowsPerPage));
    }
    if (queryParams.get("keyword")) {
      _keyword = queryParams.get("keyword");
      setSearchData({ ...searchData, keyword: _keyword });
    }
    if (queryParams.get("user")) {
      _user = queryParams.get("user");
      setSearchData({ ...searchData, user: _user });
    }
    if (queryParams.get("_order")) {
      _order = queryParams.get("_order");
      setOrder(_order);
    }
    if (queryParams.get("_orderBy")) {
      _orderBy = queryParams.get("_orderBy");
      setOrder(_orderBy);
    }
    if (queryParams.get("isDelete")) {
      _isDelete = queryParams.get("isDelete");
      setIsDelete(_isDelete);
    }
    if (queryParams.get("status")) {
      _isActive = queryParams.get("status") == 1 ? true : false;
      setSearchData({ ...searchData, status: queryParams.get("status") });
    }
    if (queryParams.get("provinceId")) {
      _provinceId = queryParams.get("provinceId");
      setSearchData({ ...searchData, provinceId: _provinceId });
    }
    if (queryParams.get("directionIds")) {
      _directionIds = queryParams.get("directionIds");
      setSearchData({ ...searchData, directionIds: _directionIds });
    }
    if (queryParams.get("statusId")) {
      _statusId = queryParams.get("statusId");
      setSearchData({ ...searchData, statusId: _statusId });
    }
    if (queryParams.get("realEstateTypeId")) {
      _realEstateTypeId = queryParams.get("realEstateTypeId");
      setSearchData({ ...searchData, realEstateTypeId: _realEstateTypeId });
    }
    GetListAll(
      _keyword,
      _langId,
      _orderBy + " " + _order,
      Number(_page) + 1,
      Number(_rowsPerPage),
      _isDelete,
      _isActive,
      undefined,
      undefined,
      _user,
      _directionIds,
      _statusId,
      _provinceId,
      _realEstateTypeId,
    );
    provinceAction.GetLookupProvince()
      .then((res) => {
        if (res?.content) {
          setOptionProvince(res.content.map(x => {
            return { ...x, value: x.id, label: x.name }
          }));
        }
      },
      )
      .catch((err) => console.log(err));
    MasterActions.GetMasterDataFromLangId({ langId })
      .then((res) => {
        if (res.realEstateTypeCache) {
          setOptionRealEstate(res.realEstateTypeCache.map(x => {
            return { ...x, value: x.id, label: x.name }
          }));
        }
        if (res.projectStatusCache) {
          setOptionStatus(res.projectStatusCache.map(x => {
            return { ...x, value: x.id, label: x.name }
          }));
        }
        if (res.directionCache) {
          setOptionDirection(res.directionCache.map(x => {
            return { ...x, value: x.id, label: x.name }
          }));
        }
      })
      .catch((err) => console.log(err));
    checkUpdatePermission();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  const GetListAll = (
    keyword,
    langId,
    sortExpression,
    pageIndex,
    pageSize,
    isDelete,
    isActive,
    isHot,
    isHomePage,
    user,
    directionIds,
    statusId,
    provinceId,
    realEstateTypeId,
    priceFrom,
    priceTo,
    acreageFrom,
    acreageTo
  ) => {
    console.log('đâsdas', provinceId)
    dispatch(appActions.ShowLoading(true))
    setPage(pageIndex - 1);
    let sortExprs = "";
    if (sortExpression) sortExprs = sortExpression;
    else sortExprs = orderBy + " " + order;
    classifiedActions
      .GetListAll(
        keyword ? keyword : searchData.keyword,
        langId,
        sortExprs,
        pageIndex,
        pageSize,
        isDelete,
        isActive,
        isHot,
        isHomePage,
        user ? user : searchData.user,
        directionIds,
        statusId,
        provinceId,
        realEstateTypeId,
        priceFrom,
        priceTo,
        acreageFrom,
        acreageTo
      )
      .then((res) => {
        if (res && res.content) {
          dispatch(appActions.ShowLoading(false))
          setNewsModels(res.content.items);
          setTotalItemCount(res.content.totalItemCount);
        }
      })
      .catch((err) => {
        dispatch(appActions.ShowLoading(false))
        console.log(err)
      });
  };

  //--- Dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [question, setQuestion] = useState("");
  const [type, setType] = useState(0);
  const [status, setStatus] = useState();
  const [optionRealEstate, setOptionRealEstate] = useState([]);
  const [updatePermission, setUpdatePermission] = useState(false);
  const [optionStatus, setOptionStatus] = useState([]);
  const [optionDirection, setOptionDirection] = useState([]);
  const [optionProvince, setOptionProvince] = useState([]);

  const handleOpenAddDialog = () => {
    const param = getParamSearch();
    history.push(UrlCollection.AddClassified + param);
  };

  const handleOpenEditDialog = (classObj) => {
    setClassId(classId);
    const param = getParamSearch();
    history.push(UrlCollection.EditClassified + classObj.id + param);
  };

  const getParamSearch = () => {
    let param = `?langId=${langId}`;
    if (page) {
      param = param + `&pageIndex=${page}`;
    }
    if (rowsPerPage) {
      param = param + `&pageSize=${rowsPerPage}`;
    }
    if (searchData?.keyword) {
      param = param + `&keyword=${searchData.keyword}`;
    }
    if (searchData?.status) {
      param = param + `&status=${searchData.status}`;
    }
    if (searchData?.user) {
      param = param + `&user=${searchData.user}`;
    }
    if (searchData?.directionIds) {
      param = param + `&directionIds=${searchData.directionIds}`;
    }
    if (searchData?.provinceId) {
      param = param + `&provinceId=${searchData.provinceId}`;
    }
    if (searchData?.statusId) {
      param = param + `&statusId=${searchData.statusId}`;
    }
    if (searchData?.realEstateTypeId) {
      param = param + `&realEstateTypeId=${searchData.realEstateTypeId}`;
    }

    param = param + `&orderBy=${orderBy}`;
    param = param + `&order=${order}`;
    param = param + `&isDelete=${isDelete}`;
    return param;
  };

  const handleOpenDeleteDialog = (classId, newsxmin) => {
    setClassId(classId);
    setNewsxmin(newsxmin);
    setOpenDeleteDialog(true);
  };

  const handleOpenConfirmDialog = (classId, type, status) => {
    setClassId(classId);
    setType(type);
    setStatus(status);
    switch (type) {
      case 1:
        setQuestion("Bạn có chắc chắn muốn ngưng kích hoạt?");
        break;
      case 2:
        setQuestion("Bạn có chắc chắn muốn kích hoạt?");
        break;
      case 3:
        setQuestion("Bạn có chắc chắn muốn ngừng hiện trên web?");
        break;
      case 4:
        setQuestion("Bạn có chắc chắn muốn hiện web?");
        break;
      case 5:
        setQuestion("Bạn có chắc chắn muốn bật trạng thái chưa bán?");
        break;
      case 6:
        setQuestion("Bạn có chắc chắn muốn xác nhận đã bán?");
        break;
      case 7:
        setQuestion("Ban co chac chan muon bo ghim tin?");
        break;
      case 8:
        setQuestion("Ban co chac chan muon ghim tin?");
        break;
    }

    setOpenConfirmDialog(true);
  };

  const checkUpdatePermission = () => {
    securityMatrixAction
      .CheckUserPermission("UPDATE", "CLASSFIED")
      .then((res) => {
        if (res && res.content) {
          setUpdatePermission(res.content.status);
          console.log("update permission", res.content.status);
        }
      })
      .catch((err) => { });
  };

  const handleChangeStatus = () => {
    const refresh = () => {
      GetListAll(
        searchData.keyword,
        langId,
        orderBy + " " + order,
        page + 1,
        rowsPerPage,
        isDelete,
        undefined,
        undefined,
        undefined,
        searchData?.user,
        searchData?.directionIds,
        searchData?.statusId,
        searchData?.provinceId,
        searchData?.realEstateTypeId,
        searchData?.price?.from,
        searchData?.price?.to,
        searchData?.area?.from,
        searchData?.area?.to,
      );
    }
    switch (type) {
      case 1:
        classifiedActions.ClassifiedDeActive(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedDeActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 2:
        classifiedActions.ClassifiedActive(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 3:
        classifiedActions.ClassifiedHideOnWeb(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 4:
        classifiedActions.ClassifiedShowOnWeb(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 5:
        classifiedActions.ClassifiedSetOnSale(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedChangeOnSaleSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 6:
        classifiedActions.ClassifiedSetSoldOut(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedChangeSoldOutSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 7:
        classifiedActions.ClassifiedHideOnIsPin(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
      case 8:
        classifiedActions.ClassifiedShowOnIsPin(classId).then(
          (res) => {
            if (res && res.content && res.content.status) {
              refresh();
              handleCloseDeleteDialog();
              ShowNotification(
                viVN.Success.ClassifiedActiveSuccess,
                NotificationMessageType.Success
              );
            }
          },
          (err) => {
            err &&
              err.errorType &&
              ShowNotification(
                viVN.Errors[err.errorType],
                NotificationMessageType.Error
              );
          }
        );
        break;
    }
    handleCloseConfirmDialog();
  };

  const changeRealEstateType = (classifiedId, realEstateTypeId) => {
    classifiedActions
      .ClassifiedChangeRealEstateType(classifiedId, realEstateTypeId)
      .then(
        (res) => {
          if (res && res.content && res.content.status) {
            GetListAll(
              searchData.keyword,
              langId,
              orderBy + " " + order,
              page + 1,
              rowsPerPage,
              isDelete,
              undefined,
              undefined,
              undefined,
              searchData.user
            );
            handleCloseDeleteDialog();
            ShowNotification(
              viVN.Success.ChangeRealEstateTypeClassifiedSuccess,
              NotificationMessageType.Success
            );
          }
        },
        (err) => {
          err &&
            err.errorType &&
            ShowNotification(
              viVN.Errors[err.errorType],
              NotificationMessageType.Error
            );
        }
      );
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  //--- Filter
  const [filterSection, setFilterSection] = useState(null);

  const handleClickFilter = (event) => {
    setFilterSection(event.currentTarget);
  };

  const handleCloseFilter = () => {
    setFilterSection(null);
  };

  const ShowNotificationError = (messages) => {
    ShowNotification(messages, NotificationMessageType.Error);
  };

  const openFilter = Boolean(filterSection);
  const idFilter = openFilter ? "popoverSlider" : undefined;

  const handleRestore = (id) => {
    // faqActions.RestoreNews(id).then(
    //   (res) => {
    //     if (res && res.content && res.content.status) {
    //       GetListAll(
    //         searchData.categoryId,
    //         searchData.title,
    //         undefined,
    //         undefined,
    //         isDelete,
    //         searchData.status,
    //         1,
    //         rowsPerPage,
    //         orderBy + ' ' + order
    //       );
    //       ShowNotification(
    //         viVN.Success.NewsRestoreSuccess,
    //         NotificationMessageType.Success
    //       );
    //     }
    //   },
    //   (err) => {
    //     err &&
    //       err.errorType &&
    //       ShowNotification(
    //         viVN.Errors[err.errorType],
    //         NotificationMessageType.Error
    //       );
    //   }
    // );
  };
  const handleDelete = () => {
    classifiedActions.ClassifiedDelete(classId).then(
      (res) => {
        if (res && res.content && res.content.status) {
          GetListAll(
            searchData.keyword,
            langId,
            orderBy + " " + order,
            page + 1,
            rowsPerPage,
            isDelete,
            undefined,
            undefined,
            undefined,
            searchData.user,
            searchData.user,
            searchData.directionIds,
            searchData.statusId,
            searchData.provinceId,
            searchData.realEstateTypeId,
            searchData.price.from,
            searchData.price.to,
            searchData.area.from,
            searchData.area.to,
          );
          handleCloseDeleteDialog();
          ShowNotification(
            viVN.Success.ClassifiedDeleteSuccess,
            NotificationMessageType.Success
          );
        }
      },
      (err) => {
        err &&
          err.errorType &&
          ShowNotification(
            viVN.Errors[err.errorType],
            NotificationMessageType.Error
          );
      }
    );
  };

  const handelChangeFeature = (newsId, value) => {
    alert("change " + newsId + " feature to" + value);
  };
  const handleClearAllField = () => {
    refresh();
    setFilterSection(null);
  };


  const onSubmit = async (data) => {
    console.log('sdkfjghsdjhuhf', data)
    let priceFrom = undefined;
    let priceTo = undefined;
    let acreageFrom = undefined;
    let acreageTo = undefined;
    if (searchData?.price?.value) {
      priceFrom = searchData.price.from;
      priceTo = searchData.price.to;
    }
    if (searchData?.area?.value) {
      acreageFrom = searchData.area.from;
      acreageTo = searchData.area.to;
    }
    await GetListAll(
      searchData.keyword,
      langId,
      orderBy + " " + order,
      page + 1,
      rowsPerPage,
      isDelete,
      searchData.status === 1 ? true : false,
      undefined,
      undefined,
      searchData.user,
      searchData.directionIds,
      searchData.statusId,
      searchData.provinceId,
      searchData.realEstateTypeId,
      priceFrom,
      priceTo,
      acreageFrom,
      acreageTo
    );
    handleCloseFilter();
  };

  const refresh = () => {
    setIsDelete(false);
    setIsShowTrash(false);
    setSearchData({
      keyword: "",
      user: "",
      status: null,
      directionIds: null,
      price: null,
      area: null,
      statusId: null,
      provinceId: null,
      realEstateTypeId: null,
    });
    history.push(UrlCollection.Classified);
    setOrderBy("createdDate");
    setOrder("desc");
    GetListAll(
      undefined,
      langId,
      orderBy + " " + order,
      page + 1,
      rowsPerPage,
      isDelete,
      undefined,
      undefined,
      undefined
    );
  };

  const handleChangeTrash = (event) => {
    setIsShowTrash(event.target.checked);
    setIsDelete(event.target.checked);
    GetListAll(
      undefined,
      langId,
      orderBy + " " + order,
      page + 1,
      rowsPerPage,
      event.target.checked,
      undefined,
      undefined,
      undefined
    );
  };

  const handleChangeSearchForm = (event) => {
    setSearchData({ ...searchData, [event.target.name]: event.target.value });
  };

  const handleChangeSearch = (value) => {
    console.log('value', value, { ...searchData, ...value })
    setSearchData({ ...searchData, ...value });
  };

  const handleEmptyTrash = () => {
    // faqActions.EmptyTrash().then(
    //   (res) => {
    //     if (res && res.content && res.content.status) {
    //       GetListAll(
    //         undefined,
    //         langId,
    //         orderBy + ' ' + order,
    //         page + 1,
    //         rowsPerPage
    //       );
    //       //handleCloseDeleteDialog();
    //       ShowNotification(
    //         viVN.Success.NewsDeleteSuccess,
    //         NotificationMessageType.Success
    //       );
    //     }
    //   },
    //   (err) => {
    //     err &&
    //       err.errorType &&
    //       ShowNotification(
    //         viVN.Errors[err.errorType],
    //         NotificationMessageType.Error
    //       );
    //   }
    // );
  };

  return (
    <div className="slider">
      <div className="d-sm-flex align-items-center justify-content-between mb-3">
        <h1 className="h3 mb-0 text-gray-800">
          Mua bán bất động sản
          <Tooltip title="Làm mới">
            <Fab
              color="primary"
              aria-label="filter"
              size="small"
              onClick={refresh}
              className="ml-2"
            >
              <RefreshIcon />
            </Fab>
          </Tooltip>
          <span>&nbsp;&nbsp;</span>
          <FormControlLabel
            control={
              <Switch
                checked={isShowTrash}
                onChange={handleChangeTrash}
                name="checkedB"
                color="primary"
              />
            }
            label="Thùng rác"
          />

        </h1>
        <ButtonGroup
          variant="contained"
          color="primary"
          aria-label="contained primary button group"
        >
          {isShowTrash && (
            <Button
              variant="contained"
              color="secondary"
              onClick={handleEmptyTrash}
              startIcon={<DeleteCircle />}
            >
              Xóa thùng rác
            </Button>
          )}

        </ButtonGroup>
        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenAddDialog}
          startIcon={<AddCircle />}
        >
          Thêm tin mua bán
        </Button>
      </div>
      <div className="d-flex justify-content-between align-items-end">
        <form id="formSearch" onSubmit={handleSubmit(onSubmit)}>
          <div className="d-flex align-items-end flex-wrap" style={{ position: 'relative', zIndex: 99 }}>
            <div className="form_group">
              <TextField
                className="w-100"
                name="keyword"
                placeholder="Từ khoá"
                variant="outlined"
                value={searchData.keyword}
                onChange={handleChangeSearchForm}
                inputRef={register}
              />
            </div>
            <div className="form_group">
              <TextField
                className="w-100"
                variant="outlined"
                name="user"
                placeholder="Người tạo"
                value={searchData.user}
                onChange={handleChangeSearchForm}
                inputRef={register}
              />
            </div>
            <div className="form_group">
              {/* <Select
                name="status"
                className="w-100 ml-2"
                placeholder="Trạng thái"
                variant="outlined"
                value={searchData.status}
                onChange={handleChangeSearchForm}
              >
                <MenuItem value={2}>----Trạng thái----</MenuItem>
                <MenuItem value={1}>Kích hoạt</MenuItem>
                <MenuItem value={0}>Không kích hoạt</MenuItem>
              </Select> */}
              <Select
                options={listStatus}
                name='status'
                value={listStatus.find(x => x.value == searchData.status) ?? null}
                onChange={data => handleChangeSearch({ status: data.value })}
                placeholder="Trạng thái"
              />

            </div>
            {optionRealEstate?.length > 0 && (
              <div className="form_group">
                <Select
                  options={optionRealEstate}
                  value={optionRealEstate.find(x => x.value == searchData?.realEstateTypeId) ?? null}
                  name='realEstateTypeId'
                  onChange={data => handleChangeSearch({ realEstateTypeId: data.value })}
                  placeholder="Loại hình BDS"
                />
              </div>
            )}
            {optionStatus?.length > 0 && (
              <div className="form_group">
                <Select
                  options={optionStatus}
                  value={optionStatus.find(x => x.value == searchData?.statusId) ?? null}
                  name='statusId'
                  onChange={data => handleChangeSearch({ statusId: data.value })}
                  placeholder="Tình trạng"
                />
              </div>
            )}
            {optionDirection?.length > 0 && (
              <div className="form_group">
                <Select
                  options={optionDirection}
                  value={optionDirection.find(x => x.value == searchData?.directionIds) ?? null}
                  name='direction'
                  onChange={data => handleChangeSearch({ directionIds: data.value })}
                  placeholder="Hướng"
                />
              </div>
            )}
            {optionProvince?.length > 0 && (
              <div className="form_group">
                <Select
                  options={optionProvince}
                  value={optionProvince.find(x => x.value == searchData?.provinceId) ?? null}
                  name='provinceId'
                  onChange={data => handleChangeSearch({ provinceId: data.value })}
                  placeholder="Chọn tỉnh"
                />
              </div>
            )}
            {areaList?.length > 0 && (
              <div className="form_group">
                <Select
                  options={areaList}
                  value={areaList.find(x => x.value == searchData?.area?.value) ?? null}
                  name='area'
                  onChange={data => handleChangeSearch({ area: data })}
                  placeholder="Diện tích"
                />
              </div>
            )}
            {landPriceList?.length > 0 && (
              <div className="form_group">
                <Select
                  options={landPriceList}
                  value={landPriceList.find(x => x.value == searchData?.price?.value) ?? null}
                  name='price'
                  onChange={data => handleChangeSearch({ price: data })}
                  placeholder="Giá đất"
                />
              </div>
            )}

            <div className="form_group">
              <Button variant="contained" color="primary" onClick={onSubmit} className="ml-2">
                <SearchIcon fontSize="small" /> Tìm kiếm
              </Button>
              <Button
                variant="contained"
                className="ml-2"
                onClick={handleClearAllField}
              >
                <ClearAllIcon fontSize="small" /> Bỏ lọc
              </Button>
            </div>
          </div>
        </form>
      </div>
      {newsModels && (
        <ListClassified
          updatePermission={updatePermission}
          totalItemCount={totalItemCount}
          newsModels={newsModels}
          GetListAll={GetListAll}
          title={searchData.title}
          categoryId={searchData.categoryId}
          isDelete={isDelete}
          editAction={handleOpenEditDialog}
          deleteAction={handleOpenDeleteDialog}
          changeStatusAction={handleOpenConfirmDialog}
          optionRealEstate={optionRealEstate}
          changeRealEstateType={changeRealEstateType}
          restoreAction={handleRestore}
          changeFeatureAction={handelChangeFeature}
          setOrder={setOrder}
          setOrderBy={setOrderBy}
          setPage={setPage}
          setRowsPerPage={setRowsPerPage}
          order={order}
          orderBy={orderBy}
          page={page}
          rowsPerPage={rowsPerPage}
          langId={langId}
        />
      )}
      {openDeleteDialog && (
        <DeleteDialog
          isOpen={openDeleteDialog}
          onClose={handleCloseDeleteDialog}
          onSuccess={handleDelete}
          header={"Xác nhận xóa"}
          content={"Bạn có chắc chắn muốn xóa?"}
          langId={langId}
        />
      )}

      {openConfirmDialog && (
        <ConfirmDialog
          open={openConfirmDialog}
          handleClose={handleCloseConfirmDialog}
          handleAccept={handleChangeStatus}
          title={"Xác nhận"}
          content={question}
          langId={langId}
        />
      )}
    </div>
  );
}
